module.exports = __webpack_public_path__ + "img/organization-1.ff36f062.jpg";